export enum LiquiditySummaryStreamElementType {
    Info = 101, //		Symbol, open/close volume, previous close price, ADV
    Volume = 102, //	Current volume
    PredRemVol = 103, // Predicted remaining volume
    PredTradVol = 104, // Predicted traded volume
    PredCloseAuctionVol = 108, //Predicted traded volume between order start and end time
}
